/**
 * Vlastné ikony ovládacích prvkov v štýle iOS: zaškrtávacie pole a prepínač sú vyplnené farbou akcie s bielym
 * znakom, vymazanie poľa je sivý krúžok s krížikom. Formát uzlov je rovnaký ako pri Lucide: [tag, atribúty].
 * Atribút uzla prebije predvolený obrys sady (fill none, stroke currentColor).
 */
const WHITE = '#ffffff'

export const UI_ICONS = {
  'ui-checkbox-off': [['rect', { x: '3.75', y: '3.75', width: '16.5', height: '16.5', rx: '5' }]],
  'ui-checkbox-on': [
    ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '5.5', fill: 'currentColor', stroke: 'none' }],
    ['path', { d: 'm7.75 12.25 2.9 2.9 5.6-6.15', stroke: WHITE, 'stroke-width': '2.1' }],
  ],
  'ui-checkbox-indeterminate': [
    ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '5.5', fill: 'currentColor', stroke: 'none' }],
    ['path', { d: 'M8 12h8', stroke: WHITE, 'stroke-width': '2.1' }],
  ],
  'ui-radio-off': [['circle', { cx: '12', cy: '12', r: '8.25' }]],
  'ui-radio-on': [
    ['circle', { cx: '12', cy: '12', r: '9', fill: 'currentColor', stroke: 'none' }],
    ['circle', { cx: '12', cy: '12', r: '3.5', fill: WHITE, stroke: 'none' }],
  ],
  'ui-clear': [
    ['circle', { cx: '12', cy: '12', r: '9', fill: 'currentColor', stroke: 'none', 'fill-opacity': '0.42' }],
    ['path', { d: 'm9.4 9.4 5.2 5.2m0-5.2-5.2 5.2', stroke: WHITE, 'stroke-width': '1.9' }],
  ],
  'ui-dot': [['circle', { cx: '12', cy: '12', r: '5', fill: 'currentColor', stroke: 'none' }]],
  'ui-star-filled': [
    [
      'path',
      {
        d: 'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z',
        fill: 'currentColor',
      },
    ],
  ],
}
